import { UserSettingsScreen } from '~/user/components/user-settings-screen/UserSettingsScreen';

export default UserSettingsScreen;
